import React from 'react';
import { withStyles } from '@material-ui/core/styles';

import MuiSwitch from '@material-ui/core/Switch';
import MuiTableCell from '@material-ui/core/TableCell';
import MuiTableRow from '@material-ui/core/TableRow';

const styles = () => ({
  halfWidth: {
    width: '50%',
  },
  quarterWidth: {
    width: '25%',
  },
});
const PayeeRow = ({ split, classes, togglePassthrough, recoupsAgainst }) => {
  const { payee } = split;

  return (
    <MuiTableRow>
      <MuiTableCell className={classes.halfWidth}>{payee.full_name}</MuiTableCell>
      <MuiTableCell className={classes.quarterWidth}>{split.percentage}%</MuiTableCell>
      <MuiTableCell className={classes.quarterWidth}>
        <MuiSwitch checked={recoupsAgainst} onClick={() => togglePassthrough(split.id)} />
      </MuiTableCell>
    </MuiTableRow>
  );
};

export default withStyles(styles)(PayeeRow);
